import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import BaseCard from '../shared/BaseCard';
import Avatar from '../shared/Avatar';
import Title from '../shared/Title';
import Text from '../shared/Text';
import { breakpoints, palette } from '../../constants/styles';
import { mp, getCampaign } from '../../constants/utils';

const StyledCheckOutPlanLink = styled.a`
  padding-bottom: 2px;
`;

const Solution = styled.div`
  display: flex;
`;

const Info = styled.div`
  margin: 0 10px 0px 30px;

  ${breakpoints.desktop} {
    // margin: 10px 10px 0px 30px;
  }
`;

const avatarStyles = css`
  flex-shrink: 0;
  margin: 5px 10px;
  position: absolute;
  left: 0;

  transition: all 0.3s ease-out;
`;

const titleStyles = css`
  margin-left: 30px;
  margin-top: 15px;
  margin-bottom: 15px;
  
  ${breakpoints.desktop} {
    // position: absolute;
    // top: -35px;
  }
`;

const SolutionStyles = css`
  max-width: 315px;

  ${breakpoints.mobileLandscape} {
    max-width: 350px;
  }

  ${breakpoints.tablet} {
    max-width: 450px;
  }

  ${breakpoints.desktop} {
    max-width: 500px;
    align-self: flex-end;
    margin-left: 40px;
    // margin: 5px 20px;
  }
`;


const SolutionCard = ({ title, children, ctaText, ctaFunction }) => (
  <BaseCard maxWidth={300} alignSelf="flex-end" styles={SolutionStyles} noBorder>
    <Solution>
      <Avatar size={48} styles={avatarStyles} src="https://s3.us-east-2.amazonaws.com/finauta/avatars/finauta-avatar.png" />
      <Info>
        <Title level={6} color={palette.darkerGray} styles={titleStyles} medium>{title}</Title>
        <Text type="body1" styles={css`line-height: 1.4; color: ${palette.textColor}; margin: 10px 0;`}>
          {children}
        </Text>
        { ctaText !== null && (
          <StyledCheckOutPlanLink
            onClick={() => {
              mp(getCampaign(window.location.href));
              mp('Landing');
              mp('ModalMetas');
              ctaFunction();
            }}
            style={{ textAlign: 'right', marginTop: '10px', marginBottom: '-10px' }}
          >
            <Text type="normalButton" color={palette.terciaryColor}>
              {ctaText}
            </Text>
          </StyledCheckOutPlanLink>
        )}
      </Info>
    </Solution>
  </BaseCard>
);

SolutionCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  ctaFunction: PropTypes.func,
  ctaText: PropTypes.string,
};

SolutionCard.defaultProps = {
  title: '',
  children: [],
  ctaFunction: () => {},
  ctaText: null,
};

export default SolutionCard;
